import { PackageType } from 'types/subscription';

export const PACKAGE_NAMES: Record<PackageType, string> = {
  FREE: 'Trial',
  SMALL: 'Kicsi',
  MEDIUM: 'Közepes',
  LARGE: 'Nagy'
};
